import ServiceTemplate from '@/components/template/service/ServiceTemplate';
import { Title } from '@/components/atoms';

const ServiceUsagePage = () => {
  return (
    <ServiceTemplate>
      <Title>사용 내역</Title>
    </ServiceTemplate>
  );
};

export default ServiceUsagePage;
